import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=67e57f9d&scoped=true&"
import script from "./Fail.vue?vue&type=script&lang=js&"
export * from "./Fail.vue?vue&type=script&lang=js&"
import style0 from "./Fail.vue?vue&type=style&index=0&id=67e57f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e57f9d",
  null
  
)

export default component.exports